import Vue from 'vue'

import { list, show, edit, create, remove } from './categoryServices'

const state = {
  category: {},
  categories: [],
  isCategoryLoading: false,
  categorySearchResults: [],
}

const getters = {
  category: (state) => state.category,
  categories: (state) => state.categories,
  isCategoryLoading: (state) => state.isCategoryLoading,
  categorySearchResults: (state) => state.categorySearchResults,
}

const actions = {
  async fetchCategory({ commit, dispatch }, id) {
    commit('setIsCategoryLoading', true)

    try {
      const { data } = await show(id)
      commit('setCategory', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsCategoryLoading', false)
    }
  },

  async fetchCategories({ commit, dispatch, rootState }, filter = false) {
    !filter
      ? commit('setIsLoading', true)
      : commit('setIsCategoryLoading', true)

    const defaultParams = {
      size: 150,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await list(params)
      const { result, total } = data

      commit('setCategories', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      !filter
        ? commit('setIsLoading', false)
        : commit('setIsCategoryLoading', false)
    }
  },

  async createEditCategory({ commit, dispatch }, category) {
    commit('setIsCategoryLoading', true)

    try {
      category?.id ? await edit(category) : await create(category)

      dispatch(
        'showSuccessMessage',
        Vue.i18n.translate(
          `category.messages.${
            category?.id ? 'successfullyEdited' : 'successfullyCreated'
          }`
        )
      )
      dispatch('fetchCategories')
      commit('closeAllModals')
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsCategoryLoading', false)
    }
  },

  async removeCategory({ commit, dispatch }, categoryId) {
    commit('setIsCategoryLoading', true)

    try {
      await remove(categoryId)

      dispatch(
        'showSuccessMessage',
        Vue.i18n.translate('category.messages.successfullyDeleted')
      )
      dispatch('fetchCategories')
      commit('closeAllModals')
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsCategoryLoading', false)
    }
  },

  async searchCategories({ commit, dispatch }, term) {
    commit('setCategorySearchResults', [])
    commit('setIsCategoryLoading', true)

    const params = { search: term }

    try {
      const { data } = await list(params)
      commit('setCategorySearchResults', data?.result)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsCategoryLoading', false)
    }
  },

  handleOpenCreateCategoryModal({ dispatch, commit }, categoryId) {
    commit('setCategory', null)
    dispatch('openModal', 'CREATE_EDIT_CATEGORY_MODAL')
    categoryId && dispatch('fetchCategory', categoryId)
  },

  handleDeleteCategoryModal({ dispatch, commit }, categoryId) {
    commit('setCategory', null)
    dispatch('openModal', 'DELETE_CATEGORY_MODAL')
    categoryId && dispatch('fetchCategory', categoryId)
  },
}

const mutations = {
  setCategory: (state, category) => {
    state.category = category
  },

  setCategories: (state, categories) => {
    state.categories = categories
  },

  setIsCategoryLoading: (state, status) => {
    state.isCategoryLoading = status
  },

  setCategorySearchResults: (state, result) => {
    state.categorySearchResults = result
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
